import React from 'react';

const InstagramIcon = () => {
    return (
        <>
             <svg
                  width="35"
                  height="35"
                  viewBox="0 0 59 59"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_2734_17482)">
                    <g clipPath="url(#clip1_2734_17482)">
                      <path
                        d="M39.167 20.4845H39.183M21.667 12.9845H38.333C39.4274 12.9844 40.5111 13.1998 41.5222 13.6185C42.5333 14.0372 43.4521 14.651 44.226 15.4248C44.9999 16.1986 45.6138 17.1173 46.0326 18.1284C46.4514 19.1394 46.667 20.2231 46.667 21.3175V37.9845C46.667 39.0789 46.4514 40.1626 46.0326 41.1736C45.6138 42.1847 44.9999 43.1034 44.226 43.8772C43.4521 44.651 42.5333 45.2648 41.5222 45.6835C40.5111 46.1022 39.4274 46.3176 38.333 46.3175H21.667C20.5726 46.3176 19.4889 46.1022 18.4778 45.6835C17.4667 45.2648 16.5479 44.651 15.774 43.8772C15.0001 43.1034 14.3862 42.1847 13.9674 41.1736C13.5486 40.1626 13.333 39.0789 13.333 37.9845V21.3175C13.333 20.2231 13.5486 19.1394 13.9674 18.1284C14.3862 17.1173 15.0001 16.1986 15.774 15.4248C16.5479 14.651 17.4667 14.0372 18.4778 13.6185C19.4889 13.1998 20.5726 12.9844 21.667 12.9845ZM36.667 28.6015C36.7954 29.4676 36.7519 30.3504 36.5391 31.1997C36.3262 32.049 35.9482 32.848 35.4266 33.5512C34.3731 34.9713 32.7986 35.9147 31.0495 36.174C30.1834 36.3024 29.3006 36.2589 28.4513 36.0461C27.602 35.8332 26.803 35.4552 26.0998 34.9336C24.6797 33.8801 23.7363 32.3056 23.477 30.5565C23.2178 28.8074 23.664 27.0269 24.7174 25.6068C25.7709 24.1867 27.3454 23.2432 29.0945 22.984C30.8436 22.7247 32.6241 23.1709 34.0442 24.2244C35.4643 25.2779 36.4078 26.8524 36.667 28.6015Z"
                        stroke="url(#paint0_linear_2734_17482)"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_2734_17482"
                      x1="19.165"
                      y1="-6.98548"
                      x2="43.3495"
                      y2="78.6105"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#1F8D82" />
                      <stop offset="1" stopColor="#88C5BF" />
                    </linearGradient>
                    <clipPath id="clip0_2734_17482">
                      <rect
                        y="-0.348511"
                        width="59"
                        height="59"
                        rx="12"
                        fill="white"
                      />
                    </clipPath>
                    <clipPath id="clip1_2734_17482">
                      <rect
                        width="59"
                        height="59"
                        fill="white"
                        transform="translate(0 -0.348511)"
                      />
                    </clipPath>
                  </defs>
                </svg>
        </>
    );
};

export default InstagramIcon;